import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "7 5 34 38.08"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M37.437 12H38v-1.5C38 7.468 35.532 5 32.5 5h-16a5.507 5.507 0 0 0-5.5 5.5V12h26.437zm-4.238 10c.188-1.332.503-2.643.979-3.913L35.711 14H10.573l-1.62 3.239A18.555 18.555 0 0 0 7.346 22h25.853zm6.623-3.913-1.221-3.254-1.615 4.307A15.464 15.464 0 0 0 36 24.583V40.5c0 .931-.234 1.807-.644 2.576l.089.001h.058a5.453 5.453 0 0 0 3.866-1.591A5.458 5.458 0 0 0 41 37.578V24.583c0-2.227-.396-4.412-1.178-6.496zM30.5 43c1.379 0 2.5-1.121 2.5-2.5V24.583c0-.195.02-.388.026-.583H7.07c-.041.503-.07 1.008-.07 1.513V37.5c0 3.032 2.468 5.5 5.5 5.5h14.985l2.75.027c.087-.016.174-.027.265-.027z" }, null, -1)
  ])))
}
export default { render: render }